import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';
import { HomeComponent } from './modules/home/home.component';
import { StoryComponent } from './modules/story/story.component';
import { ShortsComponent } from './modules/shorts/shorts.component';
import { ShortsPlayerComponent } from './modules/shorts-player/shorts-player.component';
import { WatchVideoComponent } from './modules/watch-video/watch-video.component';
import { EmbedComponent } from './modules/embed/embed.component';
import { AdminPlaylistComponent } from './modules/admin-playlist/admin-playlist.component';
import { WebseriesDetailComponent } from './modules/category/webseries-detail/webseries-detail.component';
import { SongComponent } from './modules/audio/song/song.component';
import { RefreshComponent } from './modules/refresh/refresh.component';
import { SeeAllStoryComponent } from './modules/see-all-story/see-all-story.component';
import { RadioComponent } from './modules/radio/radio.component';
import { MyAudioplaylistDetailComponent } from './modules/profile/my-audio-playlist/my-audio-playlist-detail/my-audio-playlist-detail.component';
import { AdvisorComponent } from './modules/advisor/advisor.component';
import { KeertanComponent } from './modules/keertan/keertan.component';
import { UsersDetailComponent } from './modules/users-detail/users-detail.component';
import { SearchComponent } from './modules/search/search.component';
import { SearchGroupComponent } from './modules/search-group/search-group.component';
import { AndroidRedirectComponent } from './shared/components/redirects/android-redirect/android-redirect.component';
import { IosRedirectComponent } from './shared/components/redirects/ios-redirect/ios-redirect.component';
import { AppDownloadRedirectComponent } from './shared/components/redirects/app-download-redirect/app-download-redirect.component';
import { AuthGuard } from './core/guards/auth.guard';
import { ZoomComponent } from './modules/zoom/zoom.component';

// import { WebseriesDetailComponent } from './modules/category/webseries-detail/webseries-detail.component';

const routes: Routes = [
  {
    path: '',
    component: HomeComponent
  },
  { path: 'AndroidApp', component: AndroidRedirectComponent },
  { path: 'iOSApp', component: IosRedirectComponent },
  { path: 'AppDownload', component: AppDownloadRedirectComponent },
  { path: 'video', component: HomeComponent },
  { path: 'video-download', component: HomeComponent },
  { path: 'audio-download', component: HomeComponent },
  { path: 'posts', loadChildren: './modules/posts/posts.module#PostsModule' },
  // App share links (new_post/<slug>) and older post paths open the web Posts pages
  { path: 'post', redirectTo: 'posts', pathMatch: 'full' },
  { path: 'post/:slug', redirectTo: 'posts/:slug' },
  { path: 'new_post/:slug', redirectTo: 'posts/:slug' },
  { path: 'new_post', redirectTo: 'posts', pathMatch: 'full' },
  // Photo share links (photos/<photo id>?imageIndex=<n>): the Photos tab; no API returns a single photo yet
  { path: 'photos/:id', redirectTo: '/posts?type=photos' },
  { path: 'photos', redirectTo: '/posts?type=photos', pathMatch: 'full' },
  { path: 'qna', component: HomeComponent },
  {
    path: 'story',
    component: StoryComponent
  },

  {
    path: 'story/:type',
    component: SeeAllStoryComponent
  },
  {
    path: 'shorts',
    component: ShortsComponent
  },
  {
    // Vertical shorts feed — separate player from watch/:video_id, which is built
    // around one video with a control bar.
    path: 'shorts/:video_id',
    component: ShortsPlayerComponent
  },
  {
    // Same feed, opened as part of a playlist. Mirrors watch/:video_id/:playlist_id/:name
    // so a playlist that mixes shorts with normal/YouTube videos keeps its sequence
    // while it hands over between the two players.
    path: 'shorts/:video_id/:playlist_id/:name',
    component: ShortsPlayerComponent
  },
  {
    path: 'loading',
    component: RefreshComponent
  },
  {
    path: 'home',
    component: HomeComponent
  },
  {
    path: 'transactions',
    redirectTo: '/profile/transaction',
    pathMatch: 'full'
  },
  {
    path: 'settings',
    redirectTo: '/profile/settings',
    pathMatch: 'full'
  },
  {
    path: 'watch-history',
    redirectTo: '/profile/history',
    pathMatch: 'full'
  },
  {
    path: 'act/:token',
    component: HomeComponent
  },
  {
    path: 'watch/:video_id',
    component: WatchVideoComponent
  },
  {
    path: 'series/:slug',
    component: WebseriesDetailComponent
  },
  {
    path: 'embed/:video_id',
    component: EmbedComponent
  },
  {
    path: 'webseries/:seriesslug',
    loadChildren: './modules/series-detail/series-detail.module#SeriesDetailModule'
  },

  {
    path: 'watch/:video_id/:playlist_id/:name',
    component: WatchVideoComponent
  },
  {
    path: 'audio/songs/:song_slug',
    component: SongComponent
    // loadChildren: './modules/audio/song/song.module#SongModule'
  },
  {
    path: 'lecture-search',
    component: SearchComponent
  },
  {
    path: 'lecture-search-group',
    component: SearchGroupComponent
  },
  {
    path: 'eyJpc3MiOiJodHRwOlwvXC8xMjcuMC4wLjE6O',
    component: AdvisorComponent
  },
  {
    path: 'zoomsadhana',
    component: ZoomComponent
  },
  {
    path: 'ZoomSadhana',
    component: ZoomComponent
  },
  {
    path: 'zoom',
    component: ZoomComponent
  },
  {
    path: 'zoom/:zoom_id',
    component: ZoomComponent
  },
  {
    path: 'sankeertan-search',
    component: KeertanComponent
  },
  {
    path: 'profile',
    loadChildren: './modules/profile/profile.module#ProfileModule'
  },

  // {
  //   path: 'playlist',
  //   loadChildren: './modules/playlist/playlist.module#PlaylistModule'
  // },
  {
    path: 'category',
    loadChildren: './modules/category/category.module#CategoryModule'
  },
  {
    path: 'radio',
    component: RadioComponent
  },
  {
    path: 'radio-homepage',
    component: RadioComponent
  },

  // {
  //   path: 'audio/playlist',
  //   loadChildren: './modules/audio-playlist-detail/audio-playlist-detail.module#AudioPlaylistDetailModule',
  // },
  {
    path: 'albums',
    loadChildren: './modules/albums/albums.module#AlbumsModule',
  },
  {
    // link.kripalunidhi.org deep links redirect to /audioAlbum/:id (also listed
    // in .well-known/apple-app-site-association's applinks paths), but no web
    // route ever matched it — same AlbumsModule as 'albums', just an alias path
    // so the child route's :album_slug param (which AlbumsComponent reads as-is
    // and passes straight through to v2/album-new?slug=) also accepts a numeric id.
    path: 'audioAlbum',
    loadChildren: './modules/albums/albums.module#AlbumsModule',
  },

  {
    path: 'album-list',
    loadChildren: './modules/album-list/album-list.module#AlbumListModule',
  },
  {
    path: 'audio-search',
    loadChildren: './modules/album-list/album-list.module#AlbumListModule',
  },
  {
    path: 'audio',
    loadChildren: './modules/album-list/album-list.module#AlbumListModule',
  },
  {
    path: 'audio-homepage',
    loadChildren: './modules/album-list/album-list.module#AlbumListModule',
  },
  {
    // Audio home page laid out like the video home page — rows fed by
    // v2/audio_static_home_page + v2/audio_live_home_page. Distinct from
    // 'audio'/'audio-homepage' above, which are the album-list search page.
    path: 'audios',
    loadChildren: './modules/audios/audios.module#AudiosModule',
  },
  {
    // Single track page: /audio/:id?albumId=… — the same shape the
    // link.kripalunidhi.org audio deep links already use. Addressed by id, not a
    // slug, because every list that links here (album-list, album detail) is fed
    // by the search index, which carries id + album_id but no reliable slug. The
    // album is a query param because the page needs it only to resolve the track.
    //
    // Declared after 'audio/songs/:song_slug' (three segments) so that route
    // keeps its own URLs, and before 'audio/:slug' below, which it shadows.
    path: 'audio/:id',
    loadChildren: './modules/audio-details/audio-details.module#AudioDetailsModule',
  },
  {
    // Shadowed by 'audio/:id' above — both are one segment under /audio, and
    // that one is declared first. Nothing in the app navigates here (it renders
    // album-list, which ignores the slug anyway); kept only so an old bookmark
    // is not silently dropped from the table.
    path: 'audio/:slug',
    loadChildren: './modules/album-list/album-list.module#AlbumListModule',
  },
  {
    path: 'audio-category',
    loadChildren: './modules/album-list/album-list.module#AlbumListModule',
  },
  {
    path: 'genre',
    loadChildren: '../app/modules/genre/genre.module#GenreModule'
  },
  {
    path: 'video/:slug',
    loadChildren: './modules/video-detail/video-detail.module#VideoDetailModule'
  },
  {
    path: 'story-detail/:slug',
    loadChildren: './modules/video-detail/video-detail.module#VideoDetailModule'
  },
  {
    path: 'video/:slug/:playlist',
    loadChildren: './modules/video-detail/video-detail.module#VideoDetailModule'
  },
  {
    path: 'content/:slug',
    loadChildren: './modules/cms/cms.module#CmsModule'
  },
  {
    path: 'contact-us',
    loadChildren: './modules/contact-us/contact-us.module#ContactUsModule'
  },
  {
    path: 'new-videos',
    loadChildren: './modules/search-core/search-core.module#SearchCoreModule'
  },
  {
    path: 'trending-videos',
    loadChildren: './modules/search-core/search-core.module#SearchCoreModule'
  },
  {
    path: 'search',
    loadChildren: './modules/search-core/search-core.module#SearchCoreModule'
  },
  {
    path: 'reset-password/:id',
    loadChildren: './modules/reset-password/reset-password.module#ResetPasswordModule'
  },
  {
    path: 'save-playlist',
    loadChildren: './modules/profile/save-playlist/save-playlist.module#SavePlaylistModule'
  },
  {
    path: 'subscription',
    loadChildren: './modules/subscription/subscription.module#SubscriptionModule'
  },
  {
    path: 'live',
    loadChildren: './modules/live-vidoes/live-vidoes.module#LiveVidoesModule'
  },
  {
    path: 'video-not-found',
    loadChildren: './modules/video-not-found/video-not-found.module#VideoNotFoundModule'
  },
  {
    path: 'checkout/:slug',
    loadChildren: './modules/checkout/checkout.module#CheckoutModule'
  },
  {
    path: 'audio-playlist-all',
    loadChildren: './modules/viewall-playlist/viewall-playlist.module#ViewallPlaylistModule'
  },
  {
    path: 'playlist-all',
    component: AdminPlaylistComponent
  },
  {
    path: 'playlist',
    component: AdminPlaylistComponent
  },
  {
    path: 'playlist/:slug',
    component: AdminPlaylistComponent
  },
  {
    path: 'videoPlaylist/:slug',
    component: AdminPlaylistComponent
  },
  {
    path: '**',
    loadChildren: './modules/page-not-found/page-not-found.module#PageNotFoundModule'
  }
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
